import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AreaMasterComponent } from './area-master/area-master.component';
import { CityMasterComponent } from './city-master/city-master.component';
import { CountryMasterComponent } from './country-master/country-master.component';
import { DistrictMasterComponent } from './district-master/district-master.component';
import { IpdPatientLocationMasterComponent } from './ipd-patient-location-master/ipd-patient-location-master.component';
import { StateMasterComponent } from './state-master/state-master.component';

const routes: Routes = [
  { path: 'citymaster', component: CityMasterComponent },
  { path: 'countrymaster', component: CountryMasterComponent },
  { path: 'statemaster', component: StateMasterComponent },
  { path: 'districtmaster', component: DistrictMasterComponent },
  { path: 'areaMaster', component: AreaMasterComponent },
  { path: 'IPDpatientLocationMaster', component: IpdPatientLocationMasterComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LocationMasterRoutingModule { }
